export default "__VITE_ASSET__DeyyySMO__"